import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: ({ params }) => params && params.backgroundColor,
    ...theme.shape.componentSpacing,
    marginTop: theme.spacing(6),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(11),
    },
  },
  title: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(5),
    },
  },
}));

export default useStyles;
